var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasViewMore)?_c('a',{staticClass:"btn-more all",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _setup.onClickViewMore()}}},[_vm._v(_vm._s(_setup.viewMoreTitle(_setup.DEFAULT_VIEW_MORE_TITLE)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }